import React from 'react';

import { useHistory } from 'react-router-dom';

import { Button, message } from 'antd';
import { MessageTwoTone } from '@ant-design/icons';

import { useChatUser, useClient } from '../../contexts';

import { ConversationType } from '../../features/Messaging/types';
import {
  ENSEMBL_PLATFORM,
  SOLIDARITY_PLATFORM,
} from 'src/features/Messaging/constants';
import { SizeType } from 'antd/lib/config-provider/SizeContext';

type ChatContactButtonViewProps = {
  contactUser: () => void;
  label?: string;
  size: SizeType;
  withoutBorder?: boolean;
};

export const ChatContactButtonView: React.FC<ChatContactButtonViewProps> = ({
  contactUser,
  label,
  size,
  withoutBorder,
}) => (
  <Button
    size={size}
    onClick={contactUser}
    style={withoutBorder ? { border: 'none' } : {}}
  >
    <MessageTwoTone />
    {label && <span>{label}</span>}
  </Button>
);

export const ChatContactButton: React.FC<{
  userId: string;
  label?: string;
  size?: SizeType;
  withoutBorder?: boolean;
}> = ({ userId, label, withoutBorder, size }) => {
  const { postMessaging } = useClient();
  const chatMe = useChatUser();

  const history = useHistory();

  const contactUser = (userId: string) => {
    postMessaging(
      '/conversations',
      {
        participants: [chatMe?.externalId, userId],
        platform: [ENSEMBL_PLATFORM, SOLIDARITY_PLATFORM],
        type: 'private',
      },
      (conversation: ConversationType) => {
        history.push(`/mes-discussions/${conversation.id}?ensembl=true`);
      },
      () => {
        message.error(
          'Une erreur est survenue lors de la création de la discussion'
        );
      }
    );
  };

  return (
    <ChatContactButtonView
      contactUser={() => contactUser(userId)}
      label={label}
      size={size}
      withoutBorder={withoutBorder}
    />
  );
};
